<span *ngIf="formGroup.disabled">
  <a href="#" (click)="edit()"><mat-icon>edit</mat-icon></a>
</span>
<span *ngIf="!formGroup.disabled">
  <button mat-button color="primary" class="auto" (click)="save()">Save</button>
  <button mat-button color="accent" class="auto" (click)="cancel()">Cancel</button>
</span>
